<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_18211_102967)">
<g clip-path="url(#clip1_18211_102967)">
<path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#FABB36"/>
<path d="M19.116 10.0201H17.692C16.908 7.84405 14.8 6.35205 12.02 6.35205H7.448V10.0201H5.86V11.3361H7.448V12.7161H5.86V14.0321H7.448V17.656H12.02C14.768 17.656 16.86 16.1761 17.664 14.0321H19.116V12.7161H17.984C18.012 12.4841 18.028 12.2441 18.028 12.0041V11.9721C18.028 11.7561 18.016 11.5441 17.996 11.3361H19.12V10.0201H19.116ZM8.728 7.52405H12.02C14.06 7.52405 15.576 8.52805 16.276 10.0161H8.728V7.52405ZM12.02 16.472H8.728V14.0281H16.268C15.564 15.4921 14.052 16.472 12.02 16.472ZM16.704 12.0321C16.704 12.2641 16.688 12.4921 16.656 12.712H8.728V11.332H16.66C16.688 11.548 16.704 11.7721 16.704 12.0001V12.0321Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_18211_102967">
<rect width="24" height="24" fill="white"/>
</clipPath>
<clipPath id="clip1_18211_102967">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
